export default "__VITE_ASSET__Bvh9t6BM__"